export const heatmapColors = ['pink', 'pink', 'rgba(190, 249, 127, 1)', 'rgba(255, 240, 141, 1)', 'rgba(255, 194, 102, 1)', 'rgba(255, 127, 127, 1)'];
// TODO: ?? - bezsensu
// [0] przezroczysty

// TODO: dodać sensowne nazwy
export const polygonColors = [
	'rgba(0,0,0,1)', //black
	'rgba(0,255,0, .35)', //green
	'rgba(125, 242, 0,.20)', //light green
	'rgba(255, 225, 28,.25)', //yellow
	'rgba(255, 153, 0,.35)', //orange
	'rgba(255,0,0,.50)', //red
]; // [0] black polygon without filling. Filling is removed in HeatMapInstaller
